import { render } from "./HomeIcon.vue?vue&type=template&id=17bddf19&scoped=true"
import script from "./HomeIcon.vue?vue&type=script&lang=js"
export * from "./HomeIcon.vue?vue&type=script&lang=js"

import "./HomeIcon.vue?vue&type=style&index=0&id=17bddf19&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17bddf19"]])

export default __exports__